import {Popover, Tooltip} from './_bootstrap';

(function () {

  //
  // Bootstrap tooltips and popovers
  //

  document
    .querySelectorAll('[data-bs-toggle="tooltip"]')
    .forEach(tooltipElement => new Tooltip(tooltipElement))

  document
    .querySelectorAll('[data-bs-toggle="popover"]')
    .forEach(popoverElement => new Popover(popoverElement, {
      // trigger: 'focus'
    }))


  //
  // Read more list
  //

  var btns = document.querySelectorAll('.read-more-list > button');
  btns.forEach(btn => {
    btn.addEventListener('click', () => {
      btn.parentElement.classList.add('toggled');
    });
  });

  //
  // Menu 2e niveau (comportement responsive/accessible)
  //

  var toggle = document.querySelector('#toggle-main-aside-menu');
  var menu = document.querySelector('#main-aside-menu');

  if (toggle) {
    toggle.addEventListener('click', function () {
      if (menu.classList.contains('is-active')) {
        this.setAttribute('aria-expanded', 'false');
        menu.classList.remove('is-active');
      } else {
        menu.classList.add('is-active');
        this.setAttribute('aria-expanded', 'true');
      }
    });

    var asideMenuBtn = menu.querySelectorAll('#main-aside-menu button');
    asideMenuBtn.forEach(btn => {
      btn.addEventListener('click', () => {
        var parent = btn.parentElement;
        parent.classList.toggle('menu-item--expanded');
        btn.setAttribute('aria-expanded', parent.classList.contains('menu-item--expanded').toString());
      });
    });

  }

})();

(function ($, Drupal) {
  Drupal.behaviors.enap_theme = {
    attach: function (context, settings) {
      $('.form-autocomplete', context).on('focus', function (e) {
        e.target.setSelectionRange(e.target.value.length, e.target.value.length)
      })
    }
  };
})(jQuery, Drupal);
